import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireRole }) {
  const { user, loading, hasRole } = useAuth();
  const loc = useLocation();

  if (loading || user === undefined) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center font-mono text-xs text-[var(--text-muted)]">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (requireRole && !hasRole(requireRole)) {
    return (
      <main className="max-w-3xl mx-auto px-6 py-20 text-center" data-testid="forbidden">
        <div className="label-kicker">403 · Forbidden</div>
        <h1 className="font-heading text-3xl font-medium tracking-tighter mt-3">You don't have access to this page</h1>
        <p className="mt-3 text-sm text-[var(--text-muted)]">This area requires the <b>{requireRole}</b> role. Contact an administrator.</p>
      </main>
    );
  }
  return children;
}
